import { createFileRoute } from "@tanstack/react-router";

import { AdminUsersPage } from "@/components/admin/AdminUsersPage";

export const Route = createFileRoute("/administrator/users")({
  head: () => ({ meta: [{ title: "Users · GENRL Admin" }] }),
  validateSearch: (raw: Record<string, unknown>) => ({
    user: typeof raw.user === "string" ? raw.user : undefined,
  }),
  component: UsersRoute,
});

function UsersRoute() {
  const search = Route.useSearch();
  return <AdminUsersPage initialUserID={search.user} />;
}
